import { useMemo } from 'react';
import { CampaignStatus } from '../interfaces/campaign';

export const useCampaignStatusColors = (status: CampaignStatus) => {
	const className = useMemo(() => {
		switch (status) {
			case 'queue_up':
				return 'bg-warning-selected text-warning-main';
			case 'in_progress':
				return 'bg-primary-selected text-primary-main';
			case 'payment_pend':
				return 'bg-secondary-selected text-secondary-main';
			case 'completed':
				return 'bg-success-selected text-success-main';
			case 'rejected':
				return 'bg-error-selected text-error-main';
			case 'pending':
				return 'bg-orange-selected text-orange-700';
			case 'pending_content':
				return 'bg-green-selected text-green-300';
			case 'confirmation_pend':
				return 'bg-purple-selected text-purple-main';
			default:
				return '';
		}
	}, [status]);

	return className;
};
